import { render, staticRenderFns } from "./SummeryBlock.vue?vue&type=template&id=3c2ad744"
import script from "./SummeryBlock.vue?vue&type=script&lang=js"
export * from "./SummeryBlock.vue?vue&type=script&lang=js"
import style0 from "./SummeryBlock.vue?vue&type=style&index=0&id=3c2ad744&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports